import { useEffect, useState } from "react";

export const LOADER_MESSAGES = {
  quiz: [
    "Reading the numbers in your birth date...",
    "Mapping your dominant chakra...",
    "Calculating your Life Path number...",
    "Selecting your prescribed crystals...",
    "Matching stones to your energy blueprint...",
    "Consulting ancient Vedic patterns...",
    "Aligning your five elements...",
    "Your prescription is taking shape...",
    "Almost ready - this was written for you...",
  ],
  payment: [
    "Sealing your prescription...",
    "Preparing your healing blueprint...",
    "Your crystals are being called forward...",
    "Confirming your sacred order...",
    "The universe has received your intention...",
  ],
  confirmation: [
    "Your prescription is now in our hands...",
    "Your healer has been notified...",
    "Your bracelet journey has begun...",
    "Sending your confirmation to WhatsApp...",
    "Your crystals are waiting to meet you...",
  ],
  general: [
    "Entering a sacred space...",
    "Preparing your reading...",
    "The stones are listening...",
    "Something was always meant for you here...",
    "Your path is being illuminated...",
  ],
};

/**
 * Full-screen branded loader.
 * context: "quiz" | "payment" | "confirmation" | "general"
 */
export default function LotusLoader({ context = "general", messages }) {
  const list = messages || LOADER_MESSAGES[context] || LOADER_MESSAGES.general;
  const [index, setIndex] = useState(0);

  useEffect(() => {
    const id = setInterval(() => {
      setIndex((i) => (i + 1) % list.length);
    }, 2000);
    return () => clearInterval(id);
  }, [list.length]);

  return (
    <div className="lotus-loader-overlay" role="status" aria-live="polite" data-testid="lotus-loader">
      <div className="lotus-stage" aria-hidden>
        <div className="lotus-ring outer" />
        <div className="lotus-ring inner" />
        {Array.from({ length: 8 }).map((_, i) => {
          const rot = (i * 360) / 8;
          const delay = (i * 0.3).toFixed(2);
          return (
            <span
              key={`petal-${i}`}
              className="lotus-petal"
              style={{
                "--rot": `${rot}deg`,
                animationDelay: `${delay}s`,
                transform: `rotate(${rot}deg) scaleY(0.55)`,
              }}
            />
          );
        })}
        <div className="lotus-core" />
      </div>

      <p className="lotus-message" key={index}>
        {list[index]}
      </p>

      <div className="flex items-center gap-2" aria-hidden>
        {Array.from({ length: 3 }).map((_, i) => (
          <span
            key={`dot-${i}`}
            className="lotus-dot"
            style={{ animationDelay: `${i * 0.16}s` }}
          />
        ))}
      </div>

      <div className="lotus-tagline">Pancha Healing &middot; Your Crystals. Prescribed.</div>
    </div>
  );
}
